// Plan fork (Design Brief screen 8) — two roads to the SAME three thinking cells:
// "Just capture it" (type, not recorded) and "Talk it through" (the recorded ④ dialogue).
// Two equal cards, one calm question — the speak road is an invitation, never pressure,
// and its recorded-ness is said up front (honesty rail; the consent screen owns the rest).
// Carries ?class=… through from Week, so the form opens on the class you were looking at.
// While the speaking coach is set aside (COACH_SET_ASIDE, src/nav.ts) the speak road is hidden, so
// /plan/start goes straight to the typed plan; the two-road page below stays for its return.

import { COACH_SET_ASIDE } from "../nav";
import { t } from "../i18n";

export function renderPlanFork(
  app: HTMLElement,
  _params: Record<string, string>,
  query: URLSearchParams,
): void {
  // Carry the class AND the week's step through (Home and the lesson page open the form on the
  // exact lesson the teacher was looking at).
  const keep = new URLSearchParams();
  for (const k of ["class", "node", "term", "week", "lesson", "stage"]) {
    const v = query.get(k);
    if (v) keep.set(k, v);
  }
  const qs = keep.toString() ? `?${keep}` : "";
  if (COACH_SET_ASIDE) {
    // replaceState, not a push: Back from the plan form must never land on /plan/start, which would
    // only send the teacher forward again. Request a route render without simulating browser history.
    history.replaceState({ ...history.state }, "", `/plan/new${qs}`);
    window.dispatchEvent(new Event("eden:rerender"));
    return;
  }
  app.innerHTML = `
    <h1>${t("fork.title")}</h1>
    <p class="hint">${t("fork.hint")}</p>

    <a class="card fork-card" data-link href="/plan/new${qs}">
      <h2 class="fork-title">${t("fork.capture")}</h2>
      <p class="fork-sub">${t("fork.capture_sub")}</p>
    </a>

    <a class="card fork-card" data-link href="/speak/new${qs}">
      <h2 class="fork-title">${t("fork.speak")}</h2>
      <p class="fork-sub">${t("fork.speak_sub")}</p>
      <p class="fork-rec">${t("fork.speak_recorded")}</p>
    </a>`;
}
